import { useCallback, useEffect, useState } from "react";
import { readsConsultsLeft } from "../../../utils/apis/booking-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { ConsultType } from "../../../utils/Enums";

export const useGetConsultsLeft = (patientId: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [nutritionistConsultsLeft, setNutritionistConsultsLeft] = useState<number | null>(null);
    const [specialistConsultsLeft, setSpecialistConsultsLeft] = useState<number | null>(null);

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchConsults = useCallback(async () => {
        if (!patientId || !idToken) return;

        setIsLoading(true);
        setError(null);

        try {
            const [nutritionist, specialist] = await Promise.all([
                readsConsultsLeft(patientId, idToken, ConsultType.Nutritionist),
                readsConsultsLeft(patientId, idToken, ConsultType.Specialist),
            ]);
            setNutritionistConsultsLeft(nutritionist);
            setSpecialistConsultsLeft(specialist);
        } catch (err: any) {
            console.error("Failed to fetch consults left:", err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [patientId, idToken]);

    useEffect(() => {
        fetchConsults();
    }, [fetchConsults]);

    return {
        nutritionistConsultsLeft,
        specialistConsultsLeft,
        isLoading,
        error,
        refetch: fetchConsults,
    };
}